import { render, staticRenderFns } from "./DashboardWidgetWiedervorlagen.vue?vue&type=template&id=66ab5572&scoped=true"
import script from "./DashboardWidgetWiedervorlagen.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetWiedervorlagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ab5572",
  null
  
)

export default component.exports